window.theme = window.theme || {};
theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();
  function formatMoney(cents, format){
    if(typeof cents === 'string'){
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);
    function formatWithDelimiters(number, precision, thousands, decimal){
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if(isNaN(number) || number == null){
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';
      return dollarsAmount + centsAmount;
    }
    switch(formatString.match(placeholderRegex)[1]){
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();
  'use strict';
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  init = function(options){
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };
    $.extend(settings, options);
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $body = $('body');
    isUpdating = false;
    if(!settings.disableAjaxCart && $addToCart.length){
      formOverride();
    }
    adjustCart();
  };
  loadCart = function(){
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function(cart){
    if($cartCountSelector){
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      if(cart.item_count === 0){
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if($cartCostSelector){
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
                                                 }
                                                 };
                                                 formOverride = function(){
                             $formContainer.on('submit', function(evt){
        evt.preventDefault();
        wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
      });
    };
    itemAddedCallback = function(product){
      wc_theme_source.lib.get_cart(cartUpdateCallback);
    };
    itemErrorCallback = function(XMLHttpRequest, textStatus){
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      $addToCart.removeClass('is-adding is-added');
      if(!!data.message){
        if(data.status == 422){
          $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
        }
      }
    };
    cartUpdateCallback = function(cart){
      updateCountPrice(cart);
      buildCart(cart);
    };
    buildCart = function(cart){
      $cartContainer.empty();
      if(cart.item_count === 0){
        $cartContainer.append('<div class="cart_empty_block"><div class="empty_cart_image_cls"><svg xmlns="http://www.w3.org/2000/svg" width="481" height="491" viewBox="0 0 481 491" fill="none"><path d="M432 91H382C377.757 91 373.687 92.6857 370.686 95.6863C367.686 98.6869 366 102.757 366 107C366 111.243 367.686 115.313 370.686 118.314C373.687 121.314 377.757 123 382 123H432C434.387 122.991 436.746 123.517 438.904 124.538C441.061 125.559 442.963 127.051 444.47 128.902C445.976 130.754 447.049 132.919 447.61 135.24C448.171 137.56 448.206 139.977 447.712 142.312L414.112 270.952C413.238 274.382 411.251 277.424 408.463 279.605C405.675 281.785 402.243 282.979 398.704 283H156.656L119.008 123H184C188.243 123 192.313 121.314 195.314 118.314C198.314 115.313 200 111.243 200 107C200 102.757 198.314 98.6869 195.314 95.6863C192.313 92.6857 188.243 91 184 91H111.472L95.552 23.336C94.727 19.8292 92.7427 16.7034 89.9203 14.4647C87.0979 12.2259 83.6025 11.0051 80 11H16C11.7565 11 7.68687 12.6857 4.68629 15.6863C1.68571 18.6869 0 22.7565 0 27C0 31.2435 1.68571 35.3131 4.68629 38.3137C7.68687 41.3143 11.7565 43 16 43H67.312L123.872 283.416C111.933 284.424 100.806 289.87 92.6847 298.678C84.5633 307.487 80.0375 319.019 80 331C80.1086 343.697 85.2006 355.843 94.1789 364.821C103.157 373.799 115.303 378.891 128 379H400C404.243 379 408.313 377.314 411.314 374.314C414.314 371.313 416 367.243 416 363C416 358.757 414.314 354.687 411.314 351.686C408.313 348.686 404.243 347 400 347H128C123.781 346.922 119.756 345.211 116.773 342.227C113.789 339.244 112.078 335.219 112 331C112 326.757 113.686 322.687 116.686 319.686C119.687 316.686 123.757 315 128 315H398.72C409.342 314.986 419.659 311.449 428.056 304.943C436.453 298.437 442.454 289.33 445.12 279.048L478.832 149.96C480.467 142.909 480.489 135.581 478.898 128.52C477.306 121.459 474.142 114.849 469.64 109.182C465.139 103.514 459.416 98.9359 452.899 95.7878C446.381 92.6398 439.238 91.0032 432 91Z" fill="black"/><path d="M392 395C382.507 395 373.226 397.815 365.333 403.089C357.439 408.364 351.287 415.86 347.654 424.631C344.021 433.402 343.07 443.053 344.922 452.364C346.774 461.675 351.346 470.228 358.059 476.941C364.772 483.654 373.325 488.226 382.636 490.078C391.947 491.93 401.598 490.979 410.369 487.346C419.14 483.713 426.636 477.561 431.911 469.667C437.185 461.774 440 452.494 440 443C440 430.27 434.943 418.061 425.941 409.059C416.939 400.057 404.73 395 392 395ZM392 459C388.836 459 385.742 458.062 383.111 456.304C380.48 454.545 378.429 452.047 377.218 449.123C376.007 446.199 375.69 442.982 376.307 439.879C376.925 436.775 378.449 433.924 380.686 431.686C382.924 429.449 385.775 427.925 388.879 427.307C391.982 426.69 395.199 427.007 398.123 428.218C401.047 429.429 403.545 431.48 405.304 434.111C407.062 436.742 408 439.835 408 443C408 447.243 406.314 451.313 403.314 454.314C400.313 457.314 396.243 459 392 459Z" fill="black"/><path d="M216 395C206.507 395 197.226 397.815 189.333 403.089C181.439 408.364 175.287 415.86 171.654 424.631C168.021 433.402 167.07 443.053 168.922 452.364C170.774 461.675 175.346 470.228 182.059 476.941C188.772 483.654 197.325 488.226 206.636 490.078C215.947 491.93 225.598 490.979 234.369 487.346C243.14 483.713 250.636 477.561 255.911 469.667C261.185 461.774 264 452.494 264 443C264 430.27 258.943 418.061 249.941 409.059C240.939 400.057 228.73 395 216 395ZM216 459C212.836 459 209.742 458.062 207.111 456.304C204.48 454.545 202.429 452.047 201.218 449.123C200.007 446.199 199.69 442.982 200.307 439.879C200.925 436.775 202.449 433.924 204.686 431.686C206.924 429.449 209.775 427.925 212.879 427.307C215.982 426.69 219.199 427.007 222.123 428.218C225.047 429.429 227.545 431.48 229.304 434.111C231.062 436.742 232 439.835 232 443C232 447.243 230.314 451.313 227.314 454.314C224.313 457.314 220.243 459 216 459Z" fill="black"/><path d="M308.042 101.998L388.262 21.7774C393.246 16.7976 393.246 8.71777 388.262 3.73801C383.278 -1.246 375.207 -1.246 370.223 3.73801L290.002 83.9585L209.777 3.73801C204.793 -1.246 196.722 -1.246 191.738 3.73801C186.754 8.71777 186.754 16.7976 191.738 21.7774L271.963 101.998L191.738 182.218C186.754 187.198 186.754 195.278 191.738 200.258C194.23 202.745 197.496 203.991 200.758 203.991C204.019 203.991 207.285 202.745 209.777 200.253L290.002 120.033L370.223 200.253C372.715 202.745 375.981 203.991 379.242 203.991C382.504 203.991 385.77 202.745 388.262 200.253C393.246 195.274 393.246 187.194 388.262 182.214L308.042 101.998Z" fill="black"/></svg></div><h5 class="empty_cart_slide_cls">' + "GEEN PRODUCTEN IN JE WINKELWAGEN." + '</h5><a href="/collections/all" class="button empty_cart_btn">'+"Terug naar shop" +'</a></div>');
        cartCallback(cart);
        return;
      }
      var items = [], item = {}, data = {}, source = $("#CartTemplate").html(), template = Handlebars.compile(source);
      $.each(cart.items, function(index, cartItem){
        if(cartItem.image != null){
          var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
        } else{
          var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
        }
        if(cartItem.properties !== null){
          $.each(cartItem.properties, function(key, value){
            if(key.charAt(0) === '_' || !value){
              delete cartItem.properties[key];
            }
          });
        }
        var freeclass ="";
        if(cartItem.variant_id == $('#FreeProductEnable').attr('data-product-id')){
          freeclass= "freegift";
        }
        else{
          freeclass = "";
        }
        item = {
          key: cartItem.key,
          line: index + 1,
          url: cartItem.url,
          img: prodImg,
          freeclass:freeclass,
          handle: cartItem.handle,
          name: cartItem.product_title,
          variation: cartItem.variant_title,
          properties: cartItem.properties,
          itemAdd: cartItem.quantity + 1,
          itemMinus: cartItem.quantity - 1,
          itemQty: cartItem.quantity,
          price: Shopify.formatMoney(cartItem.price, shop_currency),
          final_price: Shopify.formatMoney(cartItem.final_line_price, shop_currency),
          discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
          discounts: cartItem.discounts,
          discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
          vendor: cartItem.vendor
        };
        items.push(item);
      });
      data = {
        items: items,
        note: cart.note,
        totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
        totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
      };
      
      jQuery.getJSON('/cart.js', function(cart) {
        $('.head_cart_items span,.head_cart_count').text(cart.item_count);
        $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
      });
      
//       var forFreeProTotal = 0;
//       $.each(cart.items,function(index,value){
//         var pro = value.handle;
//         $('.cart_product_handles span').each(function(){
//           var total_pro = $(this).attr('data-handle');
//           if(pro == total_pro){
//             var price = value.original_line_price;
//             forFreeProTotal = forFreeProTotal + price;
//           }
//         });
//       });
//       var price = $('#FreeProductEnable').attr('data-price');
//       console.log('price',forFreeProTotal,price);
//       if(forFreeProTotal >= price){
//         console.log('forFreeProTotal',forFreeProTotal,'price',price);
//         if(!sessionStorage.getItem("freecart")){
//           var id = $('#FreeProductEnable').attr('data-product-id');
//           var qty = 1;
//           $.ajax({
//             type: "POST",
//             url: "/cart/add.js",
//             data: "quantity=" + qty + "&id=" + id,
//             dataType: "json",
//             success: function(item){
//               ajaxCart.load();
//               sessionStorage.setItem("freecart", "giftProduct");
//             },
//             error: function(XMLHttpRequest, textStatus){
//               wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
//             }
//           });
//         }
//       }else{
//         if(sessionStorage.getItem("freecart")){
//           $('.cart_free_block.freegift').find('.cart_remove_item a').trigger('click');
//           sessionStorage.removeItem('freecart');
//         }
//       }

      
      
      $cartContainer.append(template(data));
      cartCallback(cart);
    };
      
    cartCallback = function(cart){
      $body.trigger('ajaxCart.afterCartLoad', cart);
      wc_theme_source.lib.on_cart_update(cart);
      if(window.Shopify && Shopify.StorefrontExpressButtons){
        Shopify.StorefrontExpressButtons.initialize();
      }
    };

    adjustCart = function(){
      $body.on('click', '.ajaxcart__qty-adjust', function(){
       
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'), qty = parseInt($qtySelector.val());
        var qty = validateQty(qty);
        if($el.hasClass('ajaxcart__qty--plus')){
          qty += 1;
        } else{
          qty -= 1;
          if(qty <= 0) qty = 0;
        }
        if(line){
          updateQuantity(line, qty);
        } else{
          $qtySelector.val(qty);
        }    
      });

      $body.on('click', '.cart_remove_item', function(e){
        e.preventDefault();
        var line = $(this).attr('data-line');
        wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
      });
      $body.on('change', '.ajaxcart__qty-num', function(){
        if(isUpdating){
          return;
        }
        var $el = $(this), line = $el.data('line'), qty = parseInt($el.val().replace(/\D/g, ''));
        var qty = validateQty(qty);
        if(line){
          updateQuantity(line, qty);
        }
      });
      $body.on('submit', 'form.ajaxcart', function(evt){
        if(isUpdating){
          evt.preventDefault();
        }
      });
      $body.on('focus', '.ajaxcart__qty-adjust', function(){
        var $el = $(this);
        setTimeout(function(){
          $el.select();
        }, 50);
      });
      function updateQuantity(line, qty){
        isUpdating = true;
        var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');
        if(qty === 0){
          $row.parent().addClass('is-removed');
        }
        setTimeout(function(){
          wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
        }, 250);
      }
      $(document).on('click','.wn_title',function(e){
        e.preventDefault();      
        if($(this).parents('.widget_nav').find('.footer_nav').is(":visible")){
          $(this).parents('.widget_nav').find('.footer_nav').slideUp();
        }else{
          $('.widget_nav .footer_nav').slideUp();
          $(this).parents('.widget_nav').find('.footer_nav').slideDown();
        }
      });
    };
    adjustCartCallback = function(cart){
      updateCountPrice(cart);
      setTimeout(function(){
        wc_theme_source.lib.get_cart(buildCart);
        isUpdating = false;
      }, 150)
    };
    validateQty = function(qty){
      if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)){} else{
        qty = 1;
      }
      return qty;
    };
    module = {
      init: init,
      load: loadCart
    };
    return module;
  }(ajaxCart || {}, jQuery));
  
  var shop_currency_default = $('#shop_currency_val').text();
  function myCartSection() {
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight();
    $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
  }
  jQuery(window).resize(function(){
    myCartSection();
  });
  var shop_currency = shop_currency_default;;
  var wc_theme_source = {
    lib:{
      ajax_error: function(error, message){
        var data = eval('('+error.responseText+')');
        if (!!data.message) {
          $('#added_product_popup').find('h3').text(data.description);
          $('#added_product_popup').find('.cart_redirect_btn').hide();
          $('#added_product_popup').show("clip", 500);
        }
      },
      on_cart_update: function(item){
        setTimeout(function(){
          jQuery.getJSON('/cart.js', function(cart) {
            $('.cart_qty_cls').html(cart.item_count);
            if(cart.item_count > 0){
              var cart_price = Shopify.formatMoney(cart.total_price, shop_currency_default);
              if($('.items_carts span').hasClass('money')){
                $('.items_carts span').remove();
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              } else{
                $('.items_carts').html("<span class='money'>"+cart_price+"</span>");
              }
            } else{
              $('.items_carts span').remove();
              $('.items_carts').html("<span class='money'>$0.00</span>");
            }
            setTimeout(function(){            
              myCartSection();
            },1000);
          });
        },100);
        var cd_height = $('.cart_drawer_head').innerHeight() + $('.cart_drawer_footer').innerHeight();
        $('.productInCart').css('height', $(window).height() - cd_height + 'px');

        
        var forFreeProTotal = 0;
        $.each(item.items,function(index,value){
          var pro = value.handle;
          $('.cart_product_handles span').each(function(){
            var total_pro = $(this).attr('data-handle');
            if(pro == total_pro){
              var price = value.original_line_price;
              forFreeProTotal = forFreeProTotal + price;
            }
          });
        });
        var price = $('#FreeProductEnable').attr('data-price');
        if(forFreeProTotal >= price){
          console.log('forFreeProTotal',forFreeProTotal,'price',price);
          if($('.cart_drawer_items.cart_free_block.freegift').length < 1 || $('.cart_drawer_items.cart_free_block.freegift').length > 2 ){
            var id = $('#FreeProductEnable').attr('data-product-id');
            $.ajax({
              type: "POST",
              url: "/cart/add.js",
              data: "quantity=" + 1 + "&id=" + id,
              dataType: "json",
              success: function(item){
                ajaxCart.load();
              },
              error: function(XMLHttpRequest, textStatus){
                wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
              }
            });
          }
        }else{
//           if($('.cart_free_block.freegift').length > 0){
            $('.cart_free_block.freegift').find('.cart_remove').trigger('click');
//           }
        }
        
      },
      on_item_added: function(item){      
        ajaxCart.load();
      },
      on_product: function(e){
        alert("Received everything we ever wanted to know about " + e.title);
      },
      addtocart_product: function(id, qty, callback){
        var qty = qty || 1;
        var ajax = {
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + qty + "&id=" + id,
          dataType: "json",
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            jQuery.getJSON('/cart.js', function(cart) {
              $('.head_cart_items span,.head_cart_count').text(cart.item_count);
              $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
            });
            setTimeout(function(){
              $('body').addClass('CartOpen');
              $('body').removeClass('quickview_active');
            },500);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      get_product: function(handle, callback){
        jQuery.getJSON("/products/" + handle + ".js", function(product, n){
          wc_theme_source.lib.on_product(product);
        });
      },
      get_cart: function(callback){
        jQuery.getJSON("/cart.js", function(cart, textstatus){
          if((typeof callback) === 'function'){
            callback(cart);
          } else{
            wc_theme_source.lib.on_cart_update(cart);
          }
        });
      },
      addtocart_form: function(form_id, callback, errorCallback, this_click){
        var ajax = {
          type: 'POST',
          url: '/cart/add.js',
          data: jQuery('#' + form_id).serialize(),
          dataType: 'json',
          beforeSend: function(){
            jQuery('#'+form_id).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(item){
            if((typeof callback) === 'function'){
              callback(item, form_id);
            } else{
              wc_theme_source.lib.on_item_added(item);
            }
            setTimeout(function(){
              jQuery.getJSON('/cart.js', function(cart) {
                $('.head_cart_items span,.head_cart_count').text(cart.item_count);
                $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              });
            }, 500);
            setTimeout(function(){
              $('body').addClass('CartOpen');
              $('body').removeClass('quickview_active');
            },500);
          },
          error: function(XMLHttpRequest, textStatus){
            if((typeof errorCallback) === 'function'){
              errorCallback(XMLHttpRequest, textStatus);
            } else{
              wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus, this_click);
            }
          }
        };
        jQuery.ajax(ajax);
      },
      cart_change_item: function(line, qty, callback){
        var ajax = {
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=' + qty + '&line=' + line,
          dataType: 'json',
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            setTimeout(function(){
              jQuery.getJSON('/cart.js', function(cart) {
                $('.head_cart_items span,.head_cart_count').text(cart.item_count);
                $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              });
            }, 500);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_remove_item: function(line, callback){
        var ajax = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&line=" + line,
          dataType: "json",
          beforeSend: function(){
            jQuery('.cart_loader_cls_id').show();
          },
          success: function(cart){
            if((typeof callback) === 'function'){
              callback(cart);
            } else{
              wc_theme_source.lib.on_cart_update(cart);
            }
            setTimeout(function(){
              jQuery.getJSON('/cart.js', function(cart) {
                $('.head_cart_items span,.head_cart_count').text(cart.item_count);
                $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              });
            }, 500);
            jQuery('.cart_loader_cls_id').hide();
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      cart_clear_all: function(){
        var ajax = {
          type: "POST",
          url: "/cart/clear.js",
          data: "",
          dataType: "json",
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      },
      update_cart_form: function(form){
        var ajax = {
          type: "POST",
          url: "/cart/update.js",
          data: jQuery("#" + form).serialize(),
          dataType: "json",
          beforeSend: function(){
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", true);
          },
          success: function(cart){
            wc_theme_source.lib.on_cart_update(cart);
            jQuery('#'+form).find(".cart_btn_class").attr("disabled", false);
            setTimeout(function(){
              jQuery.getJSON('/cart.js', function(cart) {
                $('.head_cart_items span,.head_cart_count').text(cart.item_count);
                $('.head_cart_total').text(Shopify.formatMoney(cart.original_total_price, shop_currency));
              });
            }, 500);
          },
          error: function(XMLHttpRequest, textStatus){
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
        };
        jQuery.ajax(ajax);
      }
    }
  }
  
//   $(document).on('click','.pro_main_add_to_cart',function(e){
//     e.preventDefault();
//     var pro_id = $('.product__info-container').attr('data-id');
//     var pro_qty = $('.product_btns .quantity__input').val();
//     var ajax = {
//       type: "POST",
//       url: "/cart/add.js",
//       data: "quantity=" + pro_qty + "&id=" + pro_id,
//       dataType: "json",
//       success: function(item){
//         if((typeof callback) === 'function'){
//           callback(item, id);
//         } else{
//           wc_theme_source.lib.on_item_added(item);
//         }
//         setTimeout(function(){
//           $('body').addClass('CartOpen');
//           $('.quick_view_item').addClass('fadeInRight');
//           setTimeout(function() {
//             $('.quick_view_item').removeClass('fadeInRight');
//             $('body').removeClass('quickview_active');
//           }, 500);
//         },500);
//       },
//       error: function(XMLHttpRequest, textStatus){
//         wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
//       }
//     };
//     jQuery.ajax(ajax);
//   });

  $(document).on("click",".pro_page_add_to_cart",function(e){
    e.preventDefault();
    if($(".gift_enable_disable").prop('checked') == true){
      var normal_pro_id = $('.product__info-container').attr('data-id');
      var normal_pro_qty = $('.quantity__input').val();
      var normal_pro_prop = [];
      $('.bundle_product_block').each(function(){
        var title = $(this).attr('data-title');
        normal_pro_prop.push(title);
      });
      var items = [];
      $('.product_properties li').each(function(){
        var item = $(this).find('select').val();
        items.push(item);
      });

      var gift_pro_id = $('.gift_product_wrap').attr('data-id');
      var gift_fname = $('.gift_fname').val();
      var gift_lname = $('.gift_lname').val();
      var gift_msg = $('.gift_msg').val();
      if($(".gift_enable_disable").prop('checked') == true){
        var gift_pro_qty = 1;
      }else{
        var gift_pro_qty = 0;
      }

      var gift_card_name = $('.gift_card_name').val();
      var gift_card_msg = $('.gift_card_msg').val();

      var line_items = new Array();
      line_items = [
        {
          product_id: normal_pro_id,
          quantity: normal_pro_qty,
          propertie: {'First Item': normal_pro_prop[0],'Second Item': normal_pro_prop[1],'First Propertie':items[0],'Second Propertie':items[1],'Third Propertie':items[2],'Fourth Propertie':items[3],'Name': gift_card_name, 'Message':gift_card_msg}
        },
        {
          product_id: gift_pro_id,
          quantity: gift_pro_qty,
          propertie:{'First Name':gift_fname,'Last Name':gift_lname,'Gift Wrap Message':gift_msg}
        }
      ]
      function moveAlong(){
        var request = line_items.shift();
        var tempId= request.product_id;
        var tempQty = request.quantity;
        var tempProperties = request.propertie;
        console.log('id',tempId,'qty',tempQty,tempProperties,'data');
        var params = {
          type: 'POST',
          url: '/cart/add.js',         
          data: {quantity:tempQty, id:tempId,properties:tempProperties},         
          dataType: 'json',
          success: function(line_item){
            console.log('success');
            moveAlong();
            wc_theme_source.lib.addtocart_product(line_item.variant_id, line_item.quantity, '');
            return false;
          },
          error: function(){
            console.log('fail');
            moveAlong();
          }
        };
        $.ajax(params);
      };
      moveAlong();
    }
    else{
      var pro_id = $('.product__info-container').attr('data-id');
      var pro_qty = $('.product_btns .quantity__input').val();
      var normal_pro_prop = [];
      $('.bundle_product_block').each(function(){
        var title = $(this).attr('data-title');
        normal_pro_prop.push(title);
      });
      var items = [];
      $('.product_properties li').each(function(){
        var item = $(this).find('select').val().split('-').join(' ');
        items.push(item);
      });
      console.log('items',items);
      var gift_card_name = $('.gift_card_name').val();
      var gift_card_msg = $('.gift_card_msg').val();
      var data = {
        'First Item': normal_pro_prop[0],
        'Second Item': normal_pro_prop[1],
        'First Kit':items[0],
        'Second Kit':items[1],
        'Third Kit':items[2],
        'Fourth Kit':items[3],
        'Name': gift_card_name,
        'Message':gift_card_msg
      }
      $.post('/cart/add.js', {
        items: [
          {
            quantity: pro_qty,
            id: pro_id, 
            properties: data
          }
        ]
      },function(data){
        if((typeof callback) === 'function'){
          callback(data, pro_id);
        } else{
          wc_theme_source.lib.on_item_added(data);
        }
        setTimeout(function(){
          $('body').addClass('CartOpen');
          $('.quick_view_item').addClass('fadeInRight');
          setTimeout(function() {
            $('.quick_view_item').removeClass('fadeInRight');
            $('body').removeClass('quickview_active');
          }, 500);
        },500);
      });
             
//       var ajax = {
//         type: "POST",
//         url: "/cart/add.js",
//         data: "quantity=" + pro_qty + "&id=" + pro_id + "properties"+ data ,
//         dataType: "json",
//         success: function(item){
//           if((typeof callback) === 'function'){
//             callback(item, id);
//           } else{
//             wc_theme_source.lib.on_item_added(item);
//           }
//           setTimeout(function(){
//             $('body').addClass('CartOpen');
//             $('.quick_view_item').addClass('fadeInRight');
//             setTimeout(function() {
//               $('.quick_view_item').removeClass('fadeInRight');
//               $('body').removeClass('quickview_active');
//             }, 500);
//           },500);
//         },
//         error: function(XMLHttpRequest, textStatus){
//           wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
//         }
//       };
//       jQuery.ajax(ajax);
    }
    
    var cd_height = $('.cart_drawer_head').innerHeight() + $('.cart_drawer_footer').innerHeight();
    $('.productInCart').css('height', $(window).height() - cd_height + 'px');
  });
  
  
  //   gift product
  $(document).on("click",".gift_add_to_cart",function(e){
    e.preventDefault();
    var normal_pro_id = $('.product__info-container').attr('data-id');
    var normal_pro_qty = $('.quantity__input').val();
    var normal_pro_prop = [];
    $('.bundle_product_block').each(function(){
      var title = $(this).attr('data-title');
      normal_pro_prop.push(title);
    });
    var items = [];
    $('.product_properties li').each(function(){
      var item = $(this).find('select').val();
      items.push(item);
    });
    
    var gift_pro_id = $('.gift_product_wrap').attr('data-id');
    var gift_fname = $('.gift_fname').val();
    var gift_lname = $('.gift_lname').val();
    var gift_msg = $('.gift_msg').val();
    if($(".gift_enable_disable").prop('checked') == true){
      var gift_pro_qty = 1;
    }else{
      var gift_pro_qty = 0;
    }
    
    var gift_card_name = $('.gift_card_name').val();
    var gift_card_msg = $('.gift_card_msg').val();
    
    var line_items = new Array();
    line_items = [
      {
        product_id: normal_pro_id,
        quantity: normal_pro_qty,
        propertie: {'First Item': normal_pro_prop[0],'Second Item': normal_pro_prop[1],'First Propertie':items[0],'Second Propertie':items[1],'Third Propertie':items[2],'Fourth Propertie':items[3],'Name': gift_card_name, 'Message':gift_card_msg}
      },
      {
        product_id: gift_pro_id,
        quantity: gift_pro_qty,
        propertie:{'First Name':gift_fname,'Last Name':gift_lname,'Gift Wrap Message':gift_msg}
      }
    ]
    function moveAlong(){
      var request = line_items.shift();
      var tempId= request.product_id;
      var tempQty = request.quantity;
      var tempProperties = request.propertie;
      console.log('id',tempId,'qty',tempQty,tempProperties,'data');
      var params = {
        type: 'POST',
        url: '/cart/add.js',         
        data: {quantity:tempQty, id:tempId,properties:tempProperties},         
        dataType: 'json',
        success: function(line_item){
          console.log('success');
          moveAlong();
          wc_theme_source.lib.addtocart_product(line_item.variant_id, line_item.quantity, '');
          return false;
        },
        error: function(){
          console.log('fail');
          moveAlong();
        }
      };
      $.ajax(params);
    };
    moveAlong();
  });
  //  end gift product
  
  
  jQuery(document).on('click', '.add_to_cart_btn_cls', function(){
    var this_click = $(this).data('click');
    var temp_form_id = jQuery(this).closest('form').attr('id');
    wc_theme_source.lib.addtocart_form(temp_form_id, '', '', this_click);
    return false;
  });

  jQuery(document).on('click', '.cart_add_btn', function(){
    var this_click = $(this).data('click');
    var temp_variant_id = jQuery(this).attr('data-id');
    var temp_qty = 1;
    wc_theme_source.lib.addtocart_product(temp_variant_id, temp_qty, '', this_click);
    return false;
  });

  jQuery(document).ready(function(){
    ajaxCart.load();
  });	
  
  
  